module.exports = __webpack_public_path__ + "static/media/Bogey.4077a857.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Bogey.jpg
// module id = 26
// module chunks = 0